var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.361,
    cy: 11.8791,
    r: 9.64126,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14886 0 0 5.14886 0 11.5C0 17.8511 5.14886 23 11.5 23C17.8511 23 23 17.8511 23 11.5C23 5.14886 17.8511 0 11.5 0ZM19.4101 7.78373L9.89393 17.052C9.65214 17.2884 9.33359 17.4183 8.99569 17.4183C8.65779 17.4183 8.33924 17.2884 8.09805 17.0526L3.83233 12.8842C3.58691 12.6443 3.4497 12.3233 3.44547 11.9806C3.44124 11.6378 3.5712 11.3132 3.81117 11.0678C4.05477 10.8188 4.38118 10.6816 4.72996 10.6816C5.07874 10.6816 5.38641 10.8115 5.62759 11.0473L8.99508 14.3374L17.6136 5.94796C17.8548 5.71162 18.1739 5.58166 18.5118 5.58166C18.8497 5.58166 19.1864 5.71887 19.43 5.96791C19.67 6.21332 19.8006 6.53732 19.7963 6.88005C19.7927 7.22279 19.6555 7.54436 19.4101 7.78434V7.78373Z",
    fill: "#71C9CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.28946e010615e3521259de6afb09b2c3.svg";
export { ForwardRef as ReactComponent };